module.exports = "/shiftTasks/components/taskInstances/taskInstancesList/emptyTaskInstances-cde4f7.html";